import React from "react";
import {FiAward, FiCode, FiHeart, FiTarget, FiUsers, FiZap} from "react-icons/fi";

function About() {
    return (
        <div className="pt-24 pb-16 text-[#1a1a1a] min-h-screen">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header */}
                <div className="mb-12 text-center">
                    <div className="inline-block mb-6">
                        <div
                            className="w-24 h-1 bg-gradient-to-r from-white via-white/80 to-white mx-auto rounded-full shadow-lg shadow-white/50"></div>
                    </div>
                    <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-[#C8102E] to-[#A00D25] bg-clip-text text-transparent drop-shadow-lg">
                        About KidKat Games
                    </h1>
                    <p className="text-[#2d1810] text-lg max-w-3xl mx-auto">
                        Your trusted partner in world-class mobile application development. We're more than a
                        development studio; we're creators of immersive digital experiences.
                    </p>
                </div>

                {/* Introduction Card */}
                <div
                    className="mb-8 bg-gradient-to-br from-[#C8102E]/90 via-[#E31E3C]/90 to-[#C8102E]/90 rounded-2xl p-6 md:p-8 shadow-lg border border-white/40 backdrop-blur-sm">
                    <p className="text-white/95 text-lg leading-relaxed">
                        Welcome to <strong className="text-white">KidKat Games</strong> — your trusted partner in
                        world-class mobile application development. We're more than a development studio; we're creators
                        of immersive digital experiences, turning bold ideas into high-performance, user-focused mobile
                        apps for Android platforms.
                    </p>
                </div>

                {/* Mission Card */}
                <div
                    className="mb-8 bg-gradient-to-br from-[#C8102E]/90 via-[#E31E3C]/90 to-[#C8102E]/90 rounded-2xl p-6 md:p-8 shadow-lg border border-white/40 backdrop-blur-sm">
                    <div className="flex items-center gap-3 mb-4">
                        <div className="p-3 bg-white/20 rounded-lg border border-white/40">
                            <FiTarget className="text-white text-2xl"/>
                        </div>
                        <h2 className="text-3xl font-bold text-white">Our Mission</h2>
                    </div>
                    <p className="text-white/95 text-lg leading-relaxed">
                        Our mission is straightforward: to empower businesses and entrepreneurs to succeed in the mobile
                        ecosystem. We combine advanced technology with thoughtful design to build apps that are
                        scalable, reliable, and genuinely enjoyable for users.
                    </p>
                </div>

                {/* The KidKat Advantage */}
                <div className="mb-8">
                    <h2 className="text-3xl font-bold mb-6 text-center bg-gradient-to-r from-[#C8102E] to-[#A00D25] bg-clip-text text-transparent">
                        The KidKat Advantage
                    </h2>
                    <div className="grid md:grid-cols-2 gap-6">
                        {/* Full-Cycle Development */}
                        <div
                            className="bg-gradient-to-br from-[#C8102E]/90 via-[#E31E3C]/90 to-[#C8102E]/90 rounded-xl p-6 shadow-lg border border-white/40 backdrop-blur-sm">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="p-2 bg-white/20 rounded-lg border border-white/40">
                                    <FiCode className="text-white text-xl"/>
                                </div>
                                <h3 className="text-xl font-bold text-white">Full-Cycle Development</h3>
                            </div>
                            <p className="text-white/95 leading-relaxed">
                                From concept and strategy to UI/UX design, thorough testing, and launch on the App Store
                                and Google Play, we handle the entire development process.
                            </p>
                        </div>

                        {/* User-Centric Design */}
                        <div
                            className="bg-gradient-to-br from-[#C8102E]/90 via-[#E31E3C]/90 to-[#C8102E]/90 rounded-xl p-6 shadow-lg border border-white/40 backdrop-blur-sm">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="p-2 bg-white/20 rounded-lg border border-white/40">
                                    <FiHeart className="text-white text-xl"/>
                                </div>
                                <h3 className="text-xl font-bold text-white">User-Centric Design (UI/UX)</h3>
                            </div>
                            <p className="text-white/95 leading-relaxed">
                                Exceptional user experiences drive great products. Our designers craft intuitive,
                                seamless, and visually compelling interfaces that keep users engaged.
                            </p>
                        </div>

                        {/* Technical Expertise */}
                        <div
                            className="bg-gradient-to-br from-[#C8102E]/90 via-[#E31E3C]/90 to-[#C8102E]/90 rounded-xl p-6 shadow-lg border border-white/40 backdrop-blur-sm">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="p-2 bg-white/20 rounded-lg border border-white/40">
                                    <FiZap className="text-white text-xl"/>
                                </div>
                                <h3 className="text-xl font-bold text-white">Technical Expertise</h3>
                            </div>
                            <p className="text-white/95 leading-relaxed">
                                Our developers excel in modern native and cross-platform technologies—including Swift,
                                Kotlin, React Native, and Flutter—ensuring your app is built efficiently and prepared
                                for future growth.
                            </p>
                        </div>

                        {/* Collaborative Partnership */}
                        <div
                            className="bg-gradient-to-br from-[#C8102E]/90 via-[#E31E3C]/90 to-[#C8102E]/90 rounded-xl p-6 shadow-lg border border-white/40 backdrop-blur-sm">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="p-2 bg-white/20 rounded-lg border border-white/40">
                                    <FiUsers className="text-white text-xl"/>
                                </div>
                                <h3 className="text-xl font-bold text-white">Collaborative Partnership</h3>
                            </div>
                            <p className="text-white/95 leading-relaxed">
                                We see our clients as partners. Clear communication, transparency, and teamwork ensure
                                the final product aligns perfectly with your vision and business goals.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Beyond the Code */}
                <div
                    className="mb-8 bg-gradient-to-br from-[#C8102E]/90 via-[#E31E3C]/90 to-[#C8102E]/90 rounded-2xl p-6 md:p-8 shadow-lg border border-white/40 backdrop-blur-sm">
                    <div className="flex items-center gap-3 mb-4">
                        <div className="p-3 bg-white/20 rounded-lg border border-white/40">
                            <FiAward className="text-white text-2xl"/>
                        </div>
                        <h2 className="text-3xl font-bold text-white">Beyond the Code</h2>
                    </div>
                    <p className="text-white/95 text-lg leading-relaxed mb-4">
                        At KidKat Games, we value innovation, quality, and creativity. Whether you need an advanced
                        enterprise tool, a disruptive marketplace, or the next hit mobile game, we provide the expertise
                        to bring your idea to reality.
                    </p>
                    <p className="text-white text-xl font-semibold">
                        Ready to launch your next standout app? Let's create something extraordinary together.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default About;
